import React from "react";
import Header from "../../views/Header";
import Footer from "../home/Footer";

const PrivacyPolicy = () => {
  return (
    <div>
      {/* <Header/> */}
      <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-black text-center mt-8 md:mt-12 mb-8 text-4xl font-bold font-Cinzel">
            Privacy Policy
          </h1>
          <div className="bg-white shadow-md rounded-lg overflow-hidden">
            <div className="p-6 sm:p-8 space-y-6 text-gray-800 font-Outfit text-sm sm:text-md">
              <p>
                Privacy Policy of Verdical (“Verdical / We”) is respects the
                privacy of every person who shares personal information with us
                (including their name, address, contact number, email address,
                date of birth, credit/ debit card details, bank account
                information and information related to transactions (including
                but not limited to history, choices, method, mode and manner of
                payment etc), company, designation and the opposite descriptive
                information that you may provide about yourself and/or of other
                person used to identify such individual (“Personal Information”)
                through www.shop.verdical.in (“website”) provided if such
                Personal Information is shared with Verdical directly. The
                privacy of the private Information shared by you is vital to us
                and we strive to take reasonable care in the safety of your
                Personal Information that we receive.
              </p>
              <p>
                The goal of this Privacy Policy, as it may be updated from time
                to time, is to give you information about how we collect your
                personal information. This includes, but is not limited to, the
                following: (a) whenever you access, visit, or register on the
                Verdical website; (b) place an order (including canceling an
                order); (c) request to issue gift card(s); and (d) register the
                actual product you have purchased from a market (whether it be
                an e-market, another platform associated with; (f) complete any
                online form that is available. (g) sign up for (or read) our
                newsletter, updates, offers, or information on particular
                product(s) or service(s); (h) use any other method described on
                the website for gathering such data; I dialogue with us (through
                emails, text messaging apps like Whatsapp, letters, virtual
                chats, and other communication methods occasionally made
                available on the website; (j) use of social media platforms; (k)
                any request to have records of your personal information
                updated; (l) any other activities, services, features or
                resources we make available on the online site from time to
                time], store, use, maintain, disclose and transfer the private
                Information you provide to us through the web site or other mode
                as mentioned / set-out above. Users may, however, visit the
                online site anonymously.
              </p>
              <p>
                The Terms of Use (together with the opposing policies), which
                are available at Terms of Use, include this Policy into them and
                are subject to them. The users (anyone making a request on
                another person’s behalf) who visit, access (for any purpose),
                register, place orders, utilize services, etc. from the website
                (directly or indirectly) as described in the Terms of Use are
                subject to this Policy.
              </p>
              <p>By providing us your Personal Information, you hereby </p>
              <ul>
                <li>
                  granting permission for such information to be collected,
                  stored, used, disclosed, processed, and transferred (in India
                  or outside);
                </li>
                <li>
                  Declare that you only have the legal authority to do so or
                  that you have obtained the required consents from the
                  individuals whose information you have shared with us for the
                  purposes set forth in this Policy;{" "}
                </li>
                <li>
                  nd that you provided the information voluntarily and free from
                  compulsion.
                </li>
              </ul>
              <br />
              <br />
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
